import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalVariableService } from '../../../../services/configuration/global-variable.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { WfTableComponent } from '../../../../common/table-sort/wf-table.component';
import { AdminService } from '../../../../services/admin.service';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { GenericInputModalComponent } from '../../../../generic-modal/generic-input-modal/generic-input-modal.component';
import { Utils } from '../../../../services/utils';

@Component({
  selector: 'app-global-variable-group-modal',
  templateUrl: './global-variable-group-modal.component.html',
  styleUrls: ['./global-variable-group-modal.component.css', '../../../../styles/modals.css']
})
export class GlobalVariableGroupModalComponent implements OnInit {

  @Input() modalTitle: string;
  itemSaved: Subject<boolean> = new Subject();
  globalVariableGroupForm: FormGroup;
  filterForm: FormGroup;
  objInitialState: any;
  submitted = false;
  submitClick = false;
  errorMessage = '';
  pleaseWait = false;
  filteredGlobalVariableList = [];
  globalVariableList = [];
  isNew: boolean;
  dmSelectedUsers: any[];
  filterSettings = {
    placeholder: 'Filtrar',
    width: 130,
    checkboxLabel: 'Exibir somente valores substituídos',
    inputBoolSearchId: 'chkModifiedValues',
    showBooleanFilter: true,
    booleanConditionPropertyName: 'isDefaultValue',
    booleanTrueResult: false
  };
  selectUserByOptions = [
    { value: 0, text: 'Todos os usuários do sistema' },
    { value: 1, text: 'Usuários em grupo de variáveis globais' },
    { value: 2, text: 'Usuários não associados a grupo de variáveis globais' },
    { value: 3, text: 'Usuários em grupo de usuários'}
  ];
  selectUserBy = 0;
  availableUserGroups: any[];
  availableUsers = [];
  selectedUsers = [];
  inputModalComponent: any = GenericInputModalComponent;
  @ViewChild('globalVariableTabs', { static: false }) globalVariableTabs: TabsetComponent;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  get formData() { return this.globalVariableGroupForm.controls; }
  get filterData() { return this.filterForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private globalVariableService: GlobalVariableService,
    private admService: AdminService,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.isNew = this.objInitialState.globalVariableGroupId === undefined;
    this.createForm();
    this.onSearchUsers();
    if (!this.isNew) {
      this.getGlobalVariableGroup();
    } else {
      this.getGlobalVariableList();
    }
  }

  getGlobalVariableGroup() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.globalVariableService.getGlobalVariableGroup(this.objInitialState.globalVariableGroupId)
      .subscribe( group => {
        this.patchVariableGroupValues(group);
        this.globalVariableList = group.globalVariables;
        this.filteredGlobalVariableList = group.globalVariables;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  createForm() {
    this.globalVariableGroupForm = this.formBuilder.group({
      globalVariableGroupId: 0,
      name: [ '', Validators.compose( [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern('^[^<>:\\"\\\\\\/|?*[\\]{}\\$%¨&\\(\\)\\-\\+§`ªº\\-°\'\\^~¢¬£³²¹]+$') ])
      ],
      description: ['', [Validators.maxLength(200) ]],
      globalVariables: [ [] ],
      userIds: [ [] ]
    });
    this.filterForm = this.formBuilder.group({
      groupId: null,
      hasGlobalVariableGroup: null
    });
  }

  patchVariableGroupValues(group) {
    const globalVariables = group.globalVariables
      .map( globalVariable => {
        return delete globalVariable.extensionData;
        });
    this.globalVariableGroupForm.patchValue({
      globalVariableGroupId: group.globalVariableGroupId,
      name: group.name,
      description: group.description,
      globalVariables: group.globalVariables,
      userIds: group.userIds
    });
    this.dmSelectedUsers = group.userIds;
    this.selectedUsers = group.userIds;
  }

  getGlobalVariableList() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.globalVariableService.getAllOverriddenGlobalVariables()
      .subscribe( list => {
        this.filteredGlobalVariableList = list;
        this.globalVariableList = list;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  getGroupList() {
    this.errorMessage = '';
    this.admService.loadGroupList()
      .subscribe(result => { this.availableUserGroups = result; },
      error1 => { this.errorMessage = error1; });
  }

  getDefaultGlobalVariable(globalVariable) {
    this.errorMessage = '';
    this.globalVariableService.getDefaultGlobalVariable(globalVariable)
      .subscribe( defaultValue => {
        globalVariable.value = defaultValue.value;
      }, error1 => this.errorMessage = error1);
  }

  checkValue(globalVariable) {
    if (globalVariable.isEncrypted) {
      return `<span class="text-gray"><i class="fas fa-lock mr-2 text-sm"></i>Valor criptografado</span>`;
    } else {
      const length = 150;
      if (globalVariable.value.length > length) {
        return globalVariable.value.substr(0, length) + '...';
      } else {
        return globalVariable.value;
      }
    }
  }

  getSelectedUsers(data) {
    this.selectedUsers = data;
  }

  onChangeOverride(override, globalVariable) {
    if (!globalVariable.isDefaultValue && override) {
      this.getDefaultGlobalVariable(globalVariable);
    }
    globalVariable.isDefaultValue = override;
  }

  onChangeFilterOption(event) {
    if (event.target.value === '3') {
      this.filterForm.get('groupId').setValidators(Validators.required);
      if (!this.availableUserGroups) { this.getGroupList(); }
    } else {
      this.filterForm.get('groupId').clearValidators();
      this.filterForm.get('groupId').reset();
    }
  }

  onSearchUsers() {
    this.errorMessage = '';
    const filterParam = this.filterForm.getRawValue();
    switch (Number(this.selectUserBy)) {
      case 1:
        filterParam.hasGlobalVariableGroup = true;
        break;
      case 2:
        filterParam.hasGlobalVariableGroup = false;
        break;
      case 3:
        filterParam.groupId = (Number(filterParam.groupId));
        break;
    }
    this.admService.getUsersByGlobalVariableGroupUserFilter(filterParam)
      .subscribe( users => {
        this.availableUsers =  users;
    }, error1 => { this. errorMessage =  error1; });
  }

  onFilterList(filteredData: any[]) {
    this.filteredGlobalVariableList = filteredData;
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  onSave() {
    const data = this.globalVariableGroupForm.getRawValue();
    data.userIds = this.selectedUsers;
    data.description = data.description ? data.description.trim() : '';
    if (this.hasUsersInOtherGroups()) {
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Confirmação', 'Existem usuários que pertencem a outros grupos de configurações. Deseja confirmar as novas associações?');
        alert.then( resp => {
        if (resp.value) {
          this.saveGroup(data);
        }
      });
    } else {
      this.saveGroup(data);
    }
  }

  saveGroup(data) {
    if (this.isNew) {
      this.createNewGlobalVariableGroup(data);
    } else {
      this.updateGlobalVariableGroup(data);
    }
  }

  onEditGlobalVariable(globalVariable: any) {
    const result$ = this.modalService.showInputModal(
      this.inputModalComponent,
      'Substituir valor de variável global',
      `Insira um novo valor para a variável ${globalVariable.globalVariableName}`,
      'OK', 'Cancelar',
      `${globalVariable.value}`,
      '', '', 4000, 0, false, false
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          if (result !== null) {
            globalVariable.value = result;
          }
        }
      );
  }

  createNewGlobalVariableGroup(globalVariableGroup) {
    this.errorMessage = '';
    this.globalVariableService.createGlobalVariableGroup(globalVariableGroup)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }

  updateGlobalVariableGroup(globalVariableGroup) {
    this.errorMessage = '';
    this.globalVariableService.updateGlobalVariableGroup(globalVariableGroup)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }

  hasUsersInOtherGroups() {
    const users = [];
    this.selectedUsers.forEach(id => {
      users.push(this.availableUsers.find(u => u.id === id));
    });
    const userInAnotherGroup = users.filter(u => {
        return u.globalVariableGroupName && u.globalVariableGroupName !== this.formData.name.value;
      }
    );
    return userInAnotherGroup.length > 0;
  }


  adjustSpaces(value, formControlName) {
    Utils.adjustSpaces(value, this.globalVariableGroupForm, formControlName);
  }

}
